<mat-tab-group class="tab-group-content">
  <mat-tab label="Cadastro">
    <form [formGroup]="formCompanyRegistration">
      <div class="header-company">
        <h1>Dados Cadastrais:</h1>
      </div>
      <div class="form-container-a" fxFlex="100">
        <mat-form-field>
          <mat-label>CNPJ da Unidade</mat-label>
          <input
            [readonly]="hasCompanyMasterData()"
            matInput
            formControlName="fiscalNumber"
            (keyup.enter)="!hasCompanyMasterData() ? searchCompanyFromMDM() : null"
            [textMask]="{
              mask: fiscalNumberMask,
              guide: false,
              keepCharPositions: true
            }" />
          <mat-icon *ngIf="!hasCompanyMasterData()" matSuffix class="search-icon" alt="ícone de lupa" (click)="searchCompanyFromMDM()">search</mat-icon>
          <mat-icon *ngIf="hasCompanyMasterData()" matSuffix class="locked-icon" alt="ícone de um cadeado" style="width: 1.5vw">lock</mat-icon>
        </mat-form-field>
      </div>

      <div *ngIf="hasCompanyMasterData()" fxFlex="100" fxLayout="column">
        <div fxFlex>
          <mat-form-field fxFlex="25">
            <mat-label>CNPJ da Matriz</mat-label>
            <input
              matInput
              placeholder="CNPJ da Matriz"
              formControlName="headOfficeFiscalNumber"
              [textMask]="{
                mask: fiscalNumberMask,
                guide: false,
                keepCharPositions: true
              }"
              required />
          </mat-form-field>

          <mat-form-field fxFlex>
            <mat-label>Razão Social</mat-label>
            <input id="corporateName" matInput placeholder="Razão Social" formControlName="corporateName" style="text-overflow: ellipsis" required />
            <mat-icon id="corporateNameLock" hidden matSuffix alt="ícone de um cadeado">lock</mat-icon>
          </mat-form-field>

          <mat-form-field fxFlex>
            <mat-label>Nome Fantasia</mat-label>
            <input id="tradingName" matInput placeholder="Nome Fantasia" formControlName="tradingName" style="text-overflow: ellipsis" />
            <mat-icon id="corporateNameLock" hidden matSuffix alt="ícone de um cadeado">lock</mat-icon>
          </mat-form-field>

          <mat-form-field fxFlex="15">
            <mat-label>Tipo de Empresa</mat-label>
            <mat-select placeholder="Tipo de Empresa" formControlName="companyType" required>
              <mat-option [value]="0">Matriz</mat-option>
              <mat-option [value]="1">Filial</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div fxFlex>
          <mat-form-field fxFlex>
            <mat-label>Unidade</mat-label>
            <input matInput placeholder="Unidade" formControlName="unit" required />
          </mat-form-field>

          <mat-form-field fxFlex>
            <mat-label>Inscrição Estadual</mat-label>
            <input matInput placeholder="Inscrição Estadual" formControlName="stateRegistration" />
          </mat-form-field>

          <mat-form-field fxFlex>
            <mat-label>Inscrição Municipal</mat-label>
            <input matInput placeholder="Inscrição Municipal" formControlName="municipalRegistration" />
          </mat-form-field>

          <mat-form-field fxFlex>
            <mat-label>N° de Vidas</mat-label>
            <input matInput placeholder="N° de Vidas" required formControlName="employeeCount" />
          </mat-form-field>
        </div>
        <div fxFlex>
          <mat-form-field fxFlex>
            <mat-label>Endereço</mat-label>
            <input id="street" matInput placeholder="Endereço" formControlName="street" required />
            <mat-icon id="corporateNameLock" hidden matSuffix alt="ícone de um cadeado">lock</mat-icon>
          </mat-form-field>
          <mat-form-field fxFlex="15">
            <mat-label>Número</mat-label>
            <input id="number" matInput placeholder="Número" formControlName="number" required />
            <mat-icon id="corporateNameLock" hidden matSuffix alt="ícone de um cadeado">lock</mat-icon>
          </mat-form-field>
          <mat-form-field fxFlex>
            <mat-label>Complemento</mat-label>
            <input id="complement" matInput placeholder="Complemento" formControlName="complement" />
            <mat-icon id="corporateNameLock" hidden matSuffix alt="ícone de um cadeado">lock</mat-icon>
          </mat-form-field>
        </div>
        <div fxFlex>
          <mat-form-field fxFlex>
            <mat-label>CEP</mat-label>
            <input
              id="zipCode"
              matInput
              placeholder="CEP"
              formControlName="zipCode"
              [textMask]="{
                mask: zipCodeMask,
                guide: false,
                keepCharPositions: true
              }"
              required />
            <mat-icon id="corporateNameLock" hidden matSuffix alt="ícone de um cadeado">lock</mat-icon>
          </mat-form-field>
          <mat-form-field fxFlex>
            <mat-label>Bairro</mat-label>
            <input id="district" matInput placeholder="Bairro" formControlName="district" required />
            <mat-icon id="corporateNameLock" hidden matSuffix alt="ícone de um cadeado">lock</mat-icon>
          </mat-form-field>

          <mat-form-field fxFlex>
            <mat-label>Cidade</mat-label>
            <input id="city" matInput placeholder="Cidade" formControlName="city" required />
            <mat-icon id="corporateNameLock" hidden matSuffix alt="ícone de um cadeado">lock</mat-icon>
          </mat-form-field>

          <mat-form-field fxFlex>
            <mat-label>UF</mat-label>
            <input id="region" matInput placeholder="UF" formControlName="region" required />
            <mat-icon id="corporateNameLock" hidden matSuffix alt="ícone de um cadeado">lock</mat-icon>
          </mat-form-field>
        </div>
        <div class="register-btn-container">
          <button mat-flat-button *ngIf="!hasCompanyKey()" (click)="submitCompanyData()" class="submit-btn">CADASTRAR EMPRESA</button>
        </div>
      </div>
    </form>

    <div *ngIf="hasCompanyKey()" class="edit-control">
      <button mat-flat-button class="back-btn" (click)="backToSearchCompanies()">VOLTAR P/ PESQUISA</button>

      <button mat-flat-button class="submit-btn" (click)="submitCompanyData()">SALVAR EMPRESA</button>
    </div>
  </mat-tab>
</mat-tab-group>
